import React from 'react';
import AnnouncementFP from '../FullPagesComponents/OnBoarding/AnnouncementFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';

//= ========================================================================

const AnnouncementDF = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
}) => (
  <SimulatorsViewerArrangement>
    <AnnouncementFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
    />
  </SimulatorsViewerArrangement>
);

export default AnnouncementDF;
